import { useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button, { ButtonProps } from "@ebsco-ui/button";
import { createBemBlockBuilder as buildBEMString } from "@ebsco-ui/utils";
import { AriaLabelProp } from "../interfaces";
import { SEARCH_BUTTON_ICONS } from "./constants";

import "./search-button.scss";

const BASE_CLASS_NAME = "eb-search-button";

export type SearchButtonIconType = "search" | "searchWithin";

export interface SearchButtonProps
  extends Omit<ButtonProps, "onChange" | "styleType"> {
  className?: string;
  icon?: SearchButtonIconType;
  messages?: {
    title: string;
  } & AriaLabelProp;
  focusedByDefault?: boolean;
}

const SearchButton = ({
  className: consumerBaseClassName,
  icon = "search",
  messages,
  focusedByDefault,
  ...rest
}: SearchButtonProps) => {
  const searchButtonIcon = SEARCH_BUTTON_ICONS[icon];
  const searchButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (focusedByDefault) {
      setTimeout(() => {
        if (searchButtonRef.current) {
          searchButtonRef.current.focus();
        }
      }, 200);
    }
  }, [focusedByDefault]);

  const getBEMBlocksWith = buildBEMString([
    BASE_CLASS_NAME,
    consumerBaseClassName,
  ]);

  return (
    <Button
      {...rest}
      {...messages}
      className={getBEMBlocksWith()}
      styleType="flat-icon"
      type="submit"
      ref={searchButtonRef}
    >
      <FontAwesomeIcon
        className={getBEMBlocksWith("__icon")}
        icon={searchButtonIcon}
      />
    </Button>
  );
};

SearchButton.displayName = "SearchButton";

export default SearchButton;
